import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

// Translation stuff, see: https://github.com/ngx-translate/core
import { TranslateModule } from '@ngx-translate/core';

import { reducers, effects } from './store';
import * as fromContainers from './containers';
import * as fromServices from '../../services';
import { RegisterRoutingModule } from './register-routing.module';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('RegisterFeature', reducers),
        EffectsModule.forFeature(effects),
        FormsModule,
        ReactiveFormsModule,
        RegisterRoutingModule,
        TranslateModule.forChild({ extend: true })
    ],
    providers: [...fromServices.services],
    declarations: [...fromContainers.containers],
    exports: [...fromContainers.containers]
})
export class RegisterModule {}
